import React from 'react'

export class Endereco extends React.Component {
  render () {
    return (
      <React.Fragment>
        <div className="col-lg-4 col-md-4 col-6 mb-2"
             onClick={() => this.props.selecionarEndereco(this.props.endereco)}>
          <div className="card card-default text-left" style={{ background: this.props.enderecoSelecionado === this.props.endereco ? '#fa8d42' : '', cursor: 'pointer' }}>
            <div className='ml-2 mt-2 mb-2'>
              <p><span>{`${this.props.endereco.logradouro}, ${this.props.endereco.numero ? this.props.endereco.numero : 'S/N'}${this.props.endereco.complemento ? `, ${this.props.endereco.complemento}` : ''}`}</span></p>
              <p><span>{`${this.props.endereco.bairro} - ${this.props.endereco.localidade} - ${this.props.endereco.uf}`}</span></p>
              <p>CEP: <span>{this.props.endereco.cep}</span></p>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Endereco
